import { useLocation } from "react-router-dom";

export enum FishingDiscipline {
  TroutArea = 1,
  CarpAndCrucian = 2,
}

export const disciplineLabel = (discipline: FishingDiscipline) =>
  discipline === FishingDiscipline.CarpAndCrucian ? "Carpe e Carassi" : "Trout Area";

export function useFishingDiscipline(): FishingDiscipline {
  return useLocation().pathname.startsWith("/carpe")
    ? FishingDiscipline.CarpAndCrucian : FishingDiscipline.TroutArea;
}

export const formatKg = (weight: number) =>
  weight.toLocaleString("it-IT", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
